var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"color":"transparent","flat":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"primary--text"},[_vm._v(" Copyright ©2025 All Rights Reserved | Cinematic Celebration ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }